export const Play = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M12.8474 11.85L17.788 15L12.8474 18.15V11.85ZM10.9724 8.4375V21.5625L21.2849 15"
        fill="black"
      />
    </svg>
  );
};
